import type { ReactElement } from "react";
import { Outlet } from "react-router-dom";
import { KeyboardNavigationProvider } from "../contexts/KeyboardNavigationContext";

/**
 * Wrapper component that provides KeyboardNavigationContext within the router
 * This allows the provider to access useLocation for path-based disabling
 */
export function KeyboardNavigationWrapper(): ReactElement {
  return (
    <KeyboardNavigationProvider>
      <Outlet />
    </KeyboardNavigationProvider>
  );
}
